module.exports = __webpack_public_path__ + "img/metamask-icon.0302f731.png";